import { Button } from '@amore/ui/components/button'
import { FileInput } from '@amore/ui/components/file-input'
import { Download, FileText, Trash2, Upload } from 'lucide-react'
import { newId } from '@/lib/format'
import type { Venue } from '@/mock/venues'

export function VenueMaterials({
  documents,
  onChange,
  canEdit = false,
}: {
  documents: Venue['documents']
  onChange?: (documents: Venue['documents']) => void
  canEdit?: boolean
}) {
  const download = (file: File) => {
    const url = URL.createObjectURL(file)
    const link = document.createElement('a')
    link.href = url
    link.download = file.name
    link.click()
    window.setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
  return (
    <section className="space-y-4">
      <div className="space-y-1">
        <h3 className="text-sm font-semibold">Soubory k místu</h3>
        <p className="text-sm text-muted-foreground">
          Dohody, půdorys, pravidla nebo pokyny pro dodavatele.
        </p>
      </div>
      {canEdit ? (
        <FileInput
          multiple
          onChange={(event) => {
            const files = Array.from(event.target.files ?? [])
            onChange?.([...documents, ...files.map((file) => ({ id: newId('file'), file }))])
          }}
        >
          <Upload aria-hidden="true" className="size-4" /> Přidat soubory
        </FileInput>
      ) : null}
      {documents.length ? (
        <ul className="divide-y divide-border">
          {documents.map(({ id, file }) => (
            <li key={id} className="flex items-center gap-2 py-3">
              <FileText aria-hidden="true" className="size-5 shrink-0 text-muted-foreground" />
              <div className="min-w-0 flex-1">
                <p className="break-words text-sm font-medium">{file.name}</p>
                <p className="text-xs text-muted-foreground">
                  {Math.max(1, Math.round(file.size / 1024))} kB
                </p>
              </div>
              <Button
                appearance="ghost"
                tone="neutral"
                size="icon"
                aria-label={`Stáhnout ${file.name}`}
                onClick={() => download(file)}
              >
                <Download aria-hidden="true" className="size-4" />
              </Button>
              {canEdit ? (
                <Button
                  appearance="ghost"
                  tone="neutral"
                  size="icon"
                  aria-label={`Odebrat ${file.name}`}
                  onClick={() => onChange?.(documents.filter((doc) => doc.id !== id))}
                >
                  <Trash2 aria-hidden="true" className="size-4" />
                </Button>
              ) : null}
            </li>
          ))}
        </ul>
      ) : (
        <p className="py-5 text-sm text-muted-foreground">Zatím tu nejsou žádné soubory.</p>
      )}
    </section>
  )
}
